import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { XCircle, ArrowLeft, ShoppingCart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { fireEvent } from '@/lib/analytics';
import { getCartCount } from '@/lib/cartStore';

export default function CheckoutCancel() {
  useEffect(() => {
    // Track checkout cancellation
    fireEvent('checkout_cancel', {
      item_count: getCartCount(),
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Checkout Cancelled | Attain Domains</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>

      <div className="min-h-screen bg-background py-12 px-4">
        <div className="max-w-2xl mx-auto">
          {/* Cancel Header */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-muted mb-4">
              <XCircle className="w-8 h-8 text-muted-foreground" />
            </div>
            <h1 className="text-3xl font-bold text-foreground mb-2">Checkout Cancelled</h1>
            <p className="text-muted-foreground">
              You cancelled the checkout process. Your cart items are still saved.
            </p>
          </div>

          {/* Info Card */}
          <Card className="mb-8">
            <CardContent className="p-6">
              <h2 className="text-lg font-semibold text-foreground mb-3">What happened?</h2>
              <p className="text-muted-foreground mb-4">
                Your checkout with a trusted payment provider was cancelled before completion.
                Don't worry—the domains you selected are still in your cart, and you can try again
                whenever you're ready.
              </p>
              <p className="text-sm text-muted-foreground">
                If you encountered an issue or have questions, please{' '}
                <Link to="/contact" className="text-primary hover:underline">
                  contact me
                </Link>{' '}
                and we'll be happy to help.
              </p>
            </CardContent>
          </Card>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Button asChild className="flex-1" size="lg">
              <Link to="/cart">
                <ShoppingCart className="w-4 h-4 mr-2" />
                Return to Cart
              </Link>
            </Button>
            <Button asChild variant="outline" className="flex-1" size="lg">
              <Link to="/domains">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Continue Browsing
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
